/**
 * Reprise de session au rechargement de la page.
 *
 * Le bureau ne garde que le jeton de rafraîchissement : au chargement, il fait un appel anodin
 * (`api.onboarding()`) pour savoir si la session tient encore — `request` rafraîchit le jeton
 * d'accès si besoin. Mais cet appel exige un droit (`onboarding:read:tenant`) que seuls
 * l'administrateur et la comptabilité détiennent : pour un responsable, un planificateur ou un
 * lecteur, l'API répond « refusé » (HTTP 403) alors que la session est parfaitement valide.
 *
 * Un refus (403) prouve au contraire que l'API a reconnu l'utilisateur : la session tient. Seule
 * une session réellement perdue (le rafraîchissement échoue : 401, puis retour au login) ou une
 * panne doit renvoyer à l'écran de connexion.
 */
import { ApiError } from '../api/client';

/** Vrai si l'erreur de la sonde est un simple refus de droit : l'utilisateur est bien connecté. */
export function sessionTenueMalgreRefus(erreur: unknown): boolean {
  return erreur instanceof ApiError && erreur.status === 403;
}
